import hotkeysPlugin from './hotkeys'
import pusherPlugin from './pusher'
import toastPlugin from './toast'

export default {
  install(app) {
    // Register all plugins
    app.use(hotkeysPlugin)
    app.use(pusherPlugin)
    app.use(toastPlugin)
  }
}
